import React, { useRef, useEffect } from 'react';
import { Select, MenuItem, FormControl } from '@mui/material';

// MicSettings — split-button wrapper: renders the provided trigger button (Test / End Call) on the
// left and an attached caret on the right that toggles an inline mic device-picker + live level meter.
// Mirrors the campaign email node's Save split-button pattern. State/logic live in the useMicDevices hook.
const MicSettings = ({ micState, roomInstance, toggleMicPanel, handleMicChange, handleSpeakerChange, children }) => {
    const groupRef = useRef(null);

    // Close the panel on an outside click; ignore clicks inside the MUI Select popover (rendered in a portal)
    useEffect(() => {
        if (!micState['open']) return;
        const handleOutside = (e) => {
            if (groupRef.current && groupRef.current.contains(e['target'])) return;
            if (e['target'].closest && e['target'].closest('.MuiPopover-root, .MuiModal-root')) return;
            toggleMicPanel();
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, [micState['open'], toggleMicPanel]);

    return (
    <div ref={groupRef} className={`mic-settings-group ${micState['open'] ? 'open' : ''}`}>
        {children}
        <button type='button' className='mic-settings-caret' aria-label='Microphone settings' onClick={toggleMicPanel}>
            <svg width='14' height='14' viewBox='0 0 20 20' aria-hidden='true'>
                <path d='M5 7l5 6 5-6' fill='none' stroke='currentColor' strokeWidth='2' />
            </svg>
        </button>
        {micState['open'] && (
            <div className='mic-settings-panel'>
                <div className='mic-settings-inner'>
                    <h4>Microphone</h4>
                    <FormControl fullWidth size='small'>
                        <Select value={micState['selectedId']} onChange={e => handleMicChange(e['target']['value'], roomInstance)} displayEmpty>
                            {micState['devices'].length === 0 && <MenuItem value=''>Default microphone</MenuItem>}
                            {micState['devices'].map(d => (<MenuItem key={d['deviceId']} value={d['deviceId']}>{d['label'] || 'Microphone'}</MenuItem>))}
                        </Select>
                    </FormControl>
                    <p className='mic-settings-hint'>Speak — the bar should move if this mic is working.</p>
                    <div className='mic-settings-meter'>
                        <div className='mic-settings-meter-fill' style={{ width: `${micState['level']}%` }} />
                    </div>
                    <h4>Speaker</h4>
                    <FormControl fullWidth size='small'>
                        <Select value={micState['speakerId']} onChange={e => handleSpeakerChange(e['target']['value'])} displayEmpty>
                            {micState['speakers'].length === 0 && <MenuItem value=''>Default speaker</MenuItem>}
                            {micState['speakers'].map(d => (<MenuItem key={d['deviceId']} value={d['deviceId']}>{d['label'] || 'Speaker'}</MenuItem>))}
                        </Select>
                    </FormControl>
                </div>
            </div>
        )}
    </div>
    );
};

export default MicSettings;
